import React, { useRef } from "react";
import "./CousinLookupLoading.css";

const INITIAL_QUIPS = [
  "Warming up the family grapevine\u2026",
  "Mapping out the branches\u2026",
  "Rounding up the relatives\u2026",
  "Laying out the red string\u2026",
  "Preparing the detective board\u2026",
  "Loading two centuries of connections\u2026",
  "Getting the cousins in order\u2026",
  "Charting the family constellation\u2026",
];

const SEARCH_QUIPS = [
  "Tracing the connection\u2026",
  "Following the branches\u2026",
  "Connecting the dots\u2026",
  "Asking the ancestors\u2026",
  "Climbing the family tree\u2026",
];

function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function CousinLookupLoading({ mode = "initial" }) {
  const initialQuip = useRef(pickRandom(INITIAL_QUIPS));
  const searchQuip = useRef(pickRandom(SEARCH_QUIPS));

  if (mode === "searching") {
    return (
      <div className="cousin-search-indicator">
        <div className="cousin-search-beam" />
        <span className="cousin-search-text">
          {searchQuip.current}
        </span>
      </div>
    );
  }

  // mode === "initial"
  return (
    <div className="cousin-loading">
      {/* Animated connection nodes: dot - line - dot - line - dot */}
      <div className="cousin-nodes">
        <span className="cousin-node" />
        <span className="cousin-line" />
        <span className="cousin-node" />
        <span className="cousin-line" />
        <span className="cousin-node" />
      </div>

      <p className="cousin-loading-title">{initialQuip.current}</p>

      <p className="cousin-loading-hint">
        Select two family members to discover their connection.
      </p>
    </div>
  );
}

export default CousinLookupLoading;
